module.exports = __webpack_public_path__ + "28b0047a1e0a2b2b486281a522716729.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/anna-henningsen.jpg
// module id = 655
// module chunks = 0